module.exports = __webpack_public_path__ + "img/featuredartist (5).882e4334.jpg";